export const CHAT_TAKEOVER_CLASSNAME = 'drift-frame-chat__takeover'
